import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpinstance, httpinstancefile } from "../../axios/api";
import { optional } from "zod";

export const getallairports = createAsyncThunk("getallairports", async () => {
  try {
    const url = "airports";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const getallshipments = createAsyncThunk("getallshipments", async () => {
  try {
    const url = "list_ocean_port";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
const exponentialToDecimal = (exponential) => {
  let decimal = exponential.toString().toLowerCase();
  if (decimal.includes("e+")) {
    const exponentialSplitted = decimal.split("e+");
    let postfix = "";
    for (
      let i = 0;
      i <
      +exponentialSplitted[1] -
        (exponentialSplitted[0].includes(".")
          ? exponentialSplitted[0].split(".")[1].length
          : 0);
      i++
    ) {
      postfix += "0";
    }
    const addCommas = (text) => {
      let j = 3;
      let textLength = text.length;
      while (j < textLength) {
        text = `${text.slice(0, textLength - j)},${text.slice(
          textLength - j,
          textLength
        )}`;
        textLength++;
        j += 3 + 1;
      }
      return text;
    };
    decimal = addCommas(exponentialSplitted[0].replace(".", "") + postfix);
  }
  if (decimal.toLowerCase().includes("e-")) {
    const exponentialSplitted = decimal.split("e-");
    let prefix = "0.";
    for (let i = 0; i < +exponentialSplitted[1] - 1; i++) {
      prefix += "0";
    }
    decimal = prefix + exponentialSplitted[0].replace(".", "");
  }
  return decimal;
};
export const searchrates = createAsyncThunk(
  "searchrates",
  async (values, { getState, rejectWithValue }) => {
    try {
      const payloadData = JSON.parse(JSON.stringify(values));
      delete payloadData.searchquery;
      delete payloadData.destinationcityName;
      delete payloadData.destinationcountryName;
      delete payloadData.origincityName;
      delete payloadData.origincountryName;
      const bodyParams = {
        airlinepayloadData: payloadData,
        ...values.searchquery,
      };
      const responseCargoRes = await httpinstance.post(
        "search_cargo_result",
        bodyParams
      );
      let payloadResponse = { ...responseCargoRes };
      // console.log(payloadResponse,payloadResponse?.data,payloadResponse?.data?.nodeData,"payloadResponse");
      delete values.searchquery;
      // let data=responseCargoRes?.data
      // let data2=responseCargoRes?.data?.nodeData
      // let finaldata=structuredClone(responseCargoRes?.data?.nodeData)
      // let data3=values
      // console.log(data,data2,data3,"data");
      let payloadResponse1 = {
        ...payloadResponse.data,
        // ...responseCargoRes?.data,
        // data,
        nodeData: {
          ...payloadResponse?.data?.nodeData,

          // bookingId: "hi",
          // ...responseCargoRes?.data?.nodeData,
          // finaldata
          // ,...data3
          //...values,
          ...values,
          bookingId: payloadResponse?.data?.nodeData?.bookingId,
        },
      };

      return payloadResponse1;
    } catch (err) {
      return rejectWithValue(err?.response?.data) 
    }
  }
);



export const searchratefileup = createAsyncThunk(
  "searchratefileup",
  async (values) => {
    try {
      const url = "fileupload";
      const response = await httpinstancefile.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const searchOceanRate = createAsyncThunk(
  "searchOceanRate",
  async (values) => {
    try {
      const url = "ratesearch/all-ocean-rates";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);
export const createOceanBooking = createAsyncThunk(
  "createOceanBooking",
  async (values) => {
    try {
      const url = "ratesearch/create-ocean-booking";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const loctionFromfreightify = createAsyncThunk(
  "loctionFromfreightify",
  async ({ searchText, countryCode, mode }) => {
    try {
      const url = `ratesearch/freightify-locations-api?searchText=${encodeURIComponent(
        searchText
      )}&countryCode=${countryCode}&mode=${mode}`;

      const response = await httpinstance.get(url);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const checkblackedlist = createAsyncThunk(
  "checkblackedlist",
  async (values) => {
    try {
      const url = "checkblacklist";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const viewBreakUp = createAsyncThunk("view-break-up", async (values) => {
  try {
    const url =  !values?.queryid ? `view-break-up` : `view-break-up/${values?.queryid}` ;
    const response = await httpinstance.post(url , values);
    return response;
  } catch (err) {
    throw  err
  }
});
//POST - {{local}}/api/airVas/rate/getOptionalVas

export const getOptionalVas = createAsyncThunk("getOptionalVas", async (values) => {
  try {
    const url =  `airVas/rate/getOptionalVas` ;
    const response = await httpinstance.post(url , values);
    return response;
  } catch (err) {
    throw  err
  }
});

const initialState = {
  data: {},
  loading: false,
  allairports: {},
  allshipports: {},
  viewBreakUp : {},
  isbookingsucess: false,
  optionalvas : {},
  searchRateAnimationPayloadData : {},
  searchratesAvailableData: {}
};

const searchRatesSlice = createSlice({
  name: "searchrates",
  initialState,
  reducers: {
    clearstate: (state) => {
      state.data = {};
      state.isbookingsucess = true;
    },
    searchRateAnimation : (state , actions)=>{
      state.searchRateAnimationPayloadData = actions.payload;
    },
    clearSearchRateAvailableData : (state , actions)=> {   
      state.searchratesAvailableData = {};   
      // if (state.searchratesAvailableData?.nodeData?.airlineResponse) {
      //   state.searchratesAvailableData.nodeData.airlineResponse = [];
      // }
    },
    setsearchratesAvailableData : (state , actions)=>{
      // console.log(actions.payload,"actions.payload");
      state.searchratesAvailableData =  actions.payload
    },
     resetSearchRatesState: () => initialState,
  },
 
  extraReducers: (builder) => {
    builder.addCase(searchrates.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(searchrates.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, data: payload };
    });
    builder.addCase(searchrates.rejected, (state, { payload }) => {
      return { ...state, loading: false, data: payload };
    });
   
    builder.addCase(getallairports.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, allairports: payload?.data?.data };
    });
    builder.addCase(getallshipments.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, allshipports: payload?.data?.data };
    });
    builder.addCase(viewBreakUp.pending, (state, { payload }) => {
      return { ...state, loading: true };
    }).
    addCase(viewBreakUp.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, allshipports: payload };
    }).addCase(viewBreakUp.rejected, (state, { payload }) => {
      return { ...state, loading: false, viewBreakUp: payload };
    }).addCase(getOptionalVas.pending, (state, { payload }) => {
      return { ...state, loading: true };
    }).
    addCase(getOptionalVas.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, optionalvas: payload };
    }).addCase(getOptionalVas.rejected,(state, {payload})=>{
      return { ...state, loading: false, optionalvas: payload };
    })
  },
});

export const { clearstate ,searchRateAnimation ,setsearchratesAvailableData ,clearSearchRateAvailableData, resetSearchRatesState} = searchRatesSlice.actions;
export const searchratestate = (state) => state.searchrates;
export default searchRatesSlice.reducer;
